// extracted by mini-css-extract-plugin
export var banner = "_ew-0";
export var closeButton = "_ew-2";
export var greenCheckmark = "_ew-3";
export var hereLink = "_ew-4";
export var titleIcon = "_ew-1";